import { createSelector } from 'reselect';
import type { State } from '../../types';
import { getAppliedCustomFilterQueries } from '../filters';

export const getJqlQuery = (state: State) => state.config.jqlQuery;

export const jqlContextSelector = createSelector(
	[getJqlQuery, getAppliedCustomFilterQueries],
	// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
	(jqlQuery, jqlCustomFilters) => [jqlQuery, ...jqlCustomFilters] as string[],
);
